import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAuthContext } from './use-auth-context'

/**
 * Hook that handles automatic redirection to onboarding if not completed
 * Checks user's onboardingCompleted status and redirects when necessary
 */
export function useOnboardingRedirect() {
  const { user, isLoading } = useAuthContext()
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    // Don't redirect while loading
    if (isLoading) return

    // Don't redirect if user is not authenticated
    if (!user) return

    // Public routes that don't require onboarding check
    const publicRoutes = ['/login', '/onboarding', '/403', '/404']
    const isPublicRoute = publicRoutes.some((route) => location.pathname.startsWith(route))

    // Skip check for public routes
    if (isPublicRoute) return

    // Redirect to onboarding if not completed
    if (!user.onboardingCompleted) {
      navigate('/onboarding', { replace: true })
    }
  }, [user, isLoading, navigate, location.pathname])
}
